module.exports = __webpack_public_path__ + "static/media/carriage-club.a7d8cdce.pdf";